import React from "react";
import { Link } from "react-router-dom";

import styled from "styled-components";
import { MQ, SV } from "../../styles/styles-variables";

export const SignUpDiv = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  margin-top: 8px;
  text-align: center;
`;

export const SmallTextLink = styled(Link)`
  color: ${SV.colors.interactive1};
  font-weight: bold;
  font-size: 12px;
  text-align: right;
  :hover {
    text-decoration-line: underline;
  }
  :active {
    text-decoration-line: underline;
  }
  :focus {
    text-decoration-line: underline;
  }
`;

export const H2 = styled.h2`
  text-align: center;
  font-size: 32px;
  color: ${SV.colors.darkMain1};
  margin-bottom: 20px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  justify-content: center;
  padding-bottom: 20px;
  label {
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    margin: 4px 0 2px 0;

    @media ${MQ.mobileL} {
      margin: 5px 0 2px 0;
    }
  }
  input {
    appearance: none;
    outline: none;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    height: 32px;
    padding: 8px 10px;
    color: grey;
    transition: all 0.3s ease-in-out;
    &:focus {
      color: black;
      border: 1px solid ${SV.colors.interactive1};
    }
  }
  button {
    margin: 6px 0;
  }
`;

export const HelperText = styled.div`
  color: #666;
  font-size: 11px;
  margin: 1px 0;
  font-style: italic;
`;

export const ErrorMessage = styled.div`
  color: red;
  font-style: italic;
  font-size: 11px;
  line-height: 1.2;
  min-height: 2px;
  margin-bottom: 0;

  &:empty {
    min-height: 2px;
  }
`;

export const HelperTextHidden = styled.div`
  color: red;
  font-style: italic;
  font-size: 12px;
  margin-bottom: 2px;
  visibility: hidden;
`;

export const ErrorMessageHidden = styled.div`
  color: red;
  font-style: italic;
  font-size: 12px;
  margin-bottom: 2px;
  visibility: hidden;
`;
